import { Box } from '@mui/material';
import { StyledButton } from 'components/Buttons';
import styled, { css } from 'styled-components';
import { COLORS } from 'theme/colors';

interface ErrorWrapperProps {
  maxWidth?: '160px' | '260px';
}

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: start;
  min-width: 1024px;
  margin: 0 auto;
`;

export const FieldGroup = styled.div<{ $hidden?: boolean }>`
  display: ${(props) => (props.$hidden ? 'none' : 'grid')};
  grid-template-columns: 0.82fr 1.18fr min-content min-content auto auto;
  gap: 0.25rem;
  min-height: 31px;
`;

export const FieldLabel = styled.label`
  font-weight: 600;
  display: flex;
  margin-top: 0.5rem;
  justify-content: flex-end;
  text-align: right;
`;

export const InputWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const ErrorWrapper = styled.div<ErrorWrapperProps>`
  max-width: ${({ maxWidth }) => maxWidth || '280px'};
  display: flex;
  align-items: center;
`;

export const Error = styled.p`
  color: ${COLORS.DARK_RED};
  font-size: 0.875rem;
  margin-left: 0.6rem;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  margin: 1rem auto;
`;

export const AddNewActivityButton = styled(StyledButton)`
  border: 1px solid #999;
  color: black;
  width: 280px;
  grid-column: 2;
`;

export const RemoveActivityButton = styled.button`
  font-weight: bold;
  display: flex;
  margin-top: 0.5rem;
`;

export const StyledCurrency = styled.span<{ changed: boolean }>`
  font-weight: 800;
  color: #01143e;
  transition: color 0.3s;
  padding-left: 4px;

  ${({ changed }) =>
    changed &&
    css`
      color: #04bd6a;
    `}
`;
